import makeApiCall from "./master/axiosIndex";
// TO DO Update endpoints
export const issueApis = {
  createNewIssue: (data: any): Promise<any> =>
    makeApiCall({ url: "/issue/create", method: "post", data }),
  fetchIssueDropDown: (projectId: number, params?: any) =>
    makeApiCall({
      url: `/issue/dropdownList/${projectId}`,
      method: "get",
      params,
    }),
  changeIssueStatus: (
    issueId: number,
    status: string,
    resolution: string
  ): Promise<any> => {
    let url = `/issue/statusChange/${issueId}?status=${status}`;

    if (resolution) {
      url += `&issueResolution=${encodeURIComponent(resolution)}`; // Encode to handle special characters
    }

    return makeApiCall({
      url: url,
      method: "patch",
    });
  },
  listIssues: (data: any): Promise<any> => {
    return makeApiCall({ url: "/issue/list", method: "get", params: data });
  },
  fetchIssueById: (
    issueId: number,
    status: string,
    timestamp?: number
  ): Promise<any> =>
    makeApiCall({
      url: `/issue/id/${issueId}${timestamp ? `?ts=${timestamp}` : ""}`,
      method: "get",
      // params: {
      //   derivedProjectStatus: status,
      // },
    }),
  issueTypeList: (params?: any): Promise<any> =>
    makeApiCall({
      url: "/masters/allMasterTypes/module/IssueType",
      method: "get",
      params,
    }),
  updateIssuebyId: (data: any): Promise<any> =>
    makeApiCall({ url: "/issue/update", method: "put", data }),
  getAssigneeFilters: (projectId: string | number): Promise<any> =>
    makeApiCall({
      url: `/issue/filters/assignedBy`,
      method: "get",
      params: { projectIds: projectId },
    }),

  getStatus: (): Promise<any> =>
    makeApiCall({
      url: `/project/allStatus/module/Issue`,
      method: "get",
    }),

  getSeverityFilters: (): Promise<any> =>
    makeApiCall({
      url: `/issue/filters/severity`,
      method: "get",
    }),

  getTagsFilters: (projectId: string | number): Promise<any> =>
    makeApiCall({
      url: `/issue/filters/tags`,
      method: "get",
      params: { projectId },
    }),

  updateIssueStatus: (issueId: string | number, status: string): Promise<any> =>
    makeApiCall({
      url: `/issue/statusChange/${issueId}`,
      method: "patch",
      params: { status },
    }),
  fetchIssueStatusTimeline: (
    projectId: number,
    entityId: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/task/fetchStatusTimelines/${projectId}/Issue/${entityId}`,
      method: "get",
    });
  },
  fetchIssueActivityStreamlines: (
    projectId: number,
    entityId: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/activity/fetchActivityStreamlines/${projectId}/Issue/${entityId}`,
      method: "get",
    });
  },
};
